import React, { useState } from 'react';
import Box from '../../../../components/Box';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import CustomSwitch from '../../../../components/CustomSwitch';
import { GetProductByIdResponseProductBarcode } from '../../../../models/response/product/GetProductByIdResponse';
import { ConstantService } from '../../../../services/ConstantService';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { toast } from "react-hot-toast";
import { Helpers } from '../../../../helpers/Helpers';
import { useDispatch } from 'react-redux';
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';

interface Props {
    productBarcodesRef: any
    productBarcodes: GetProductByIdResponseProductBarcode[]
    setProductBarcodes: React.Dispatch<React.SetStateAction<GetProductByIdResponseProductBarcode[]>>
}

const Barcodes = ({
    productBarcodesRef,
    productBarcodes,
    setProductBarcodes
}: Props) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [productBarcodeId, setProductBarcodeId] = useState<string | undefined>(undefined);
    const [barcodeNo, setBarcodeNo] = useState<string | undefined>(undefined);
    const [selectedBarcodeType, setSelectedBarcodeType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState<boolean>(true);

    const saveItem = () => {
        if (Helpers.isEmpty(barcodeNo)) {
            toast.error('Barkod No alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(selectedBarcodeType)) {
            toast.error('Barkod Türü alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(productBarcodeId)) {
            var o: GetProductByIdResponseProductBarcode = {
                productBarcodeId: Helpers.generateUUID(true),
                isSelected: false,
                barcodeNo: barcodeNo,
                barcodeTypeId: selectedBarcodeType?.value,
                barcodeTypeName: selectedBarcodeType?.label,
                isCustomActive: isCustomActive,
            }

            setProductBarcodes([...productBarcodes, o])
        }
        else {
            setProductBarcodes(productBarcodes.map(function (x) {
                if (x.productBarcodeId == productBarcodeId) {
                    x.isSelected = false;
                    x.barcodeNo = barcodeNo;
                    x.barcodeTypeId = selectedBarcodeType?.value;
                    x.barcodeTypeName = selectedBarcodeType?.label;
                    x.isCustomActive = isCustomActive;
                }

                return x;
            }))
        }

        setProductBarcodeId('');
        setBarcodeNo('');
        setSelectedBarcodeType(undefined);
        setIsCustomActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = productBarcodes.filter(x => x.isSelected)[0];
        setProductBarcodeId(o.productBarcodeId);
        setBarcodeNo(o.barcodeNo);
        setSelectedBarcodeType(o.barcodeTypeId && o.barcodeTypeName ? { label: o.barcodeTypeName, value: o.barcodeTypeId } : undefined);
        setIsCustomActive(o.isCustomActive);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setProductBarcodeId('');
        setBarcodeNo('');
        setSelectedBarcodeType(undefined);
        setIsCustomActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const selectAll = () => {
        var isAllSelected = productBarcodes.length == productBarcodes.filter(x => x.isSelected).length;

        setProductBarcodes(productBarcodes.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = () => {
        setProductBarcodes(productBarcodes.filter(x => !x.isSelected));
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = productBarcodesRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const setItemSelected = (_id: string) => {
        setProductBarcodes(productBarcodes.map(function (x) {
            if (x.productBarcodeId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' ref={productBarcodesRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Barkodlar</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Barkod No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={barcodeNo} onChange={(e) => setBarcodeNo(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Barkod Türü</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedBarcodeType}
                                            onChange={setSelectedBarcodeType}
                                            onMenuOpen={() => ConstantService.getConstantList('BARCODE_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={productBarcodes.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={productBarcodes.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={productBarcodes.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={productBarcodes.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={productBarcodes.filter(x => x.isSelected).length > 0 && productBarcodes.filter(x => x.isSelected).length == productBarcodes.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Barkod No</th>
                                            <th>Barkod Türü</th>
                                            <th>Aktif</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            productBarcodes.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            productBarcodes.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.productBarcodeId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.barcodeNo}</td>
                                                    <td>{item.barcodeTypeName}</td>
                                                    <td>{item.isCustomActive ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default Barcodes;